import React from 'react';

import { DeleteOutlined } from '@ant-design/icons';

import { Button, Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';

import { useDeleteFieldGroup } from '../../../../../../../../hooks';

interface IDeleteGroupProps {
  field_group_uid: string;
}

export const DeleteGroup: React.FC<IDeleteGroupProps> = ({ field_group_uid }) => {
  const commonT = useTranslation(NSKeys.common);
  const ordersT = useTranslation(NSKeys.orders);

  const { mutate, status } = useDeleteFieldGroup();

  return (
    <Popconfirm
      title={ordersT.t('deleteOrderGroupDescription')}
      onConfirm={(e) => {
        e?.stopPropagation();
        mutate({ field_group_uid });
      }}
      okText={commonT.t('confirm')}>
      <Button
        danger
        loading={status === 'loading'}
        type={'text'}
        icon={<DeleteOutlined />}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
    </Popconfirm>
  );
};
